import React, { useRef, useState, useEffect } from "react";
import andriodsequenceVideo from "../images/android-vertical.mp4";
import andriodsequenceVideo01 from "../images/an-sequence.mp4";
import { Link } from "react-router-dom";
import Header from "./common/Header";
import Footer from "./common/Footer";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
const Androidguide = () => {
  const { t } = useTranslation();
  const [scrollTop, setScrollTop] = useState(0);
  const [isActive, setIsActive] = useState(false);
  function useMediaQuery(query) {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
      const mql = window.matchMedia(query);
      const handler = (e) => setMatches(e.matches);
      mql.addEventListener("change", handler);
      setMatches(mql.matches);
      return () => mql.removeEventListener("change", handler);
    }, [query]);
    return matches;
  }

  const isDesktop = useMediaQuery("(min-width: 1402px)");
  const wrapperRef = useRef(null);
  useEffect(() => {
    if (!isDesktop) return;
    const handleScroll = () => {
      setScrollTop(-(window.pageYOffset || document.documentElement.scrollTop));
    };

    const handleResize = () => {
      if (wrapperRef.current) {
        document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      }
    };
    if (wrapperRef.current) {
      document.body.style.height = `${wrapperRef.current.offsetHeight}px`;
      document.body.style.overflow = "auto";

      wrapperRef.current.style.transition = "transform 0.3s ease-out";
      wrapperRef.current.style.position = "fixed";
      wrapperRef.current.style.top = "0";
      wrapperRef.current.style.left = "0";
      wrapperRef.current.style.width = "100%";
      wrapperRef.current.style.padding = "0";
      wrapperRef.current.style.zIndex = "2";
      wrapperRef.current.style.display = "block";
      wrapperRef.current.style.backfaceVisibility = "hidden";
    }
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isDesktop, wrapperRef?.current?.offsetHeight]);
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.transform = `translateY(${scrollTop}px)`;
    }
  }, [scrollTop]);
  useEffect(() => {
    document.body.style.backgroundColor = "#000000";
    return () => {
      document.body.style = {};
    };
  }, []);

  const [prompt, setPrompt] = useState(null);
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const handleInstall = async () => {
    if (prompt) {
      prompt.prompt();
      await prompt.userChoice;
      setPrompt(null);
    }
  };
  // const [isMobile, setIsMobile] = useState(false);

  // useEffect(() => {
  //   const checkScreen = () => {
  //     setIsMobile(window.innerWidth <= 1402);
  //   };

  //   // First check
  //   checkScreen();

  //   // Listen resize
  //   window.addEventListener("resize", checkScreen);

  //   return () => window.removeEventListener("resize", checkScreen);
  // }, []);
  return (
    <div className="home">
      <Helmet>
        <title>{t("How to download equlix app for android")} </title>

        <meta
          name="description"
          content={t(
            "How to download Equlix app on Android. Step-by-step installation guide for the Equlix trading application.",
          )}
        />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <div className="main-page w-100" ref={wrapperRef}>
        <Header />

        <div className="instruction_page">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="sticky-block text-white">
                  <h4 className="mb-4">{t("Android Instructions")}</h4>
                  <ol>
                    <li>
                      <h5>{t("Open your preferred browser")}</h5>
                      <p>
                        {t(
                          "Chrome or the web browser that comes pre-installed on your device is best.",
                        )}
                      </p>
                    </li>

                    <li>
                      <h5>{t("Open the browser settings menu.")}</h5>
                      <p>
                        {t(
                          "Tap the ellipsis icon that opens the page settings in the browser",
                        )}
                      </p>
                    </li>

                    <li>
                      <h5>{t("Click on Add to Home Screen")}</h5>
                      <p>{t("Tap on Add to Home Screen")}</p>
                    </li>

                    <li>
                      <h5>{t("Confirm adding")}</h5>
                      <p>
                        {t(
                          "In the pop-up window, confirm adding to the main screen by clicking on Add",
                        )}
                      </p>
                    </li>
                  </ol>
                </div>
                <div className="video-wrapper">
                  <div className="video-wrapper">
                    {/* PC / Tablet Video */}
                    <video
                      className="desktop-video"
                      playsInline
                      loop
                      muted
                      autoPlay
                    >
                      <source src={andriodsequenceVideo01} type="video/mp4" />
                    </video>

                    {/* Mobile Video */}
                    <video
                      className="mobile-video"
                      playsInline
                      loop
                      muted
                      autoPlay
                    >
                      <source src={andriodsequenceVideo} type="video/mp4" />
                    </video>
                  </div>
                  {prompt && (
                    <div className="app-install-btn">
                      <button
                        className="btn site_grdbtn"
                        onClick={() => handleInstall()}
                      >
                        {t("Click to install app")}
                      </button>
                    </div>
                  )}
                  {/* <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        preload="auto"
                    >
                        <source src={andriodsequenceVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video> */}
                </div>
                <div
                  className={`inner-content ${isActive ? "show_content" : ""}`}
                >
                  <h3>{t("Trading Apps for Android")}</h3>

                  <p>
                    {t(
                      "Trading is a popular way to participate in financial markets by analyzing price movements of various assets. Today, many trading apps for Android make this process more accessible, convenient, and efficient for users.",
                    )}
                  </p>

                  <h4>{t("Best Trading App for Android")}</h4>

                  <p>
                    {t(
                      "When choosing a trading app for Android, it is important to consider the following factors:",
                    )}
                  </p>

                  <ul>
                    <li>{t("Reliability and reputation of the platform")}</li>
                    <li>{t("Licensing and regulation")}</li>
                    <li>{t("Variety of available assets")}</li>
                    <li>{t("Ease of use")}</li>
                    <li>{t("Availability of educational materials")}</li>
                    <li>{t("Demo account for practice")}</li>
                    <li>{t("Convenient funding and withdrawal methods")}</li>
                  </ul>

                  <p>
                    {t(
                      "The equlix mobile app meets all these criteria. Keep in mind that trading financial instruments involves risks, so it is important to follow a well-planned capital management strategy. Trading can generate significant profits, but it may also result in capital losses, so careful consideration of strategies and investments is essential.",
                    )}
                  </p>

                  <h4>{t("Why choose our app?")}</h4>

                  <p>
                    {t(
                      "equlix is a modern online trading app designed to help users efficiently manage their investments and access a wide range of financial market assets. We provide training and personal support regardless of your trading experience. The app allows you to monitor the market in real time and manage trades conveniently. Invest in your future with equlix and improve your financial results.",
                    )}
                  </p>

                  <h4>{t("How to start using the equlix app on Android:")}</h4>

                  <p>
                    {t(
                      "To set up the equlix app on Android, follow these steps:",
                    )}
                  </p>

                  <ol>
                    <li>
                      {t(
                        "Open your browser (we recommend Chrome or any other browser installed on your smartphone).",
                      )}
                    </li>
                    <li>{t("Go to the browser settings menu.")}</li>
                    <li>
                      {t("Tap the icon with three dots to open page options.")}
                    </li>
                    <li>{t("Select Add to Home Screen.")}</li>
                    <li>{t("Confirm your choice.")}</li>
                    <li>{t("In the pop-up window, click Add.")}</li>
                  </ol>

                  <p>
                    {t(
                      "After completing these steps, the equlix app will appear on your home screen. This provides quick access to the platform and makes online trading more convenient and efficient. With the app, users can easily access important information, monitor markets, and manage trades in just a few taps.",
                    )}
                  </p>

                  <h4>{t("Conclusion")}</h4>

                  <p>
                    {t(
                      "The equlix mobile platform is a powerful online trading app for Android that offers users extensive opportunities to participate in financial markets. It helps traders analyze the market, develop strategies, and make informed decisions to achieve their financial goals.",
                    )}
                  </p>
                </div>
                <div className="ShowHideBtn">
                  <Link
                    className="showMore"
                    onClick={() => setIsActive(!isActive)}
                  >
                    {t("Show more")}
                  </Link>
                  <Link
                    className="showLess"
                    onClick={() => {
                      setIsActive(!isActive);
                      window.scrollTo({ top: 0, behavior: "instant" });
                    }}
                  >
                    {t("Show less")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default Androidguide;
